import React from 'react';
import { FaRegObjectGroup } from 'react-icons/fa6';
import TitleEditor from '../Forms/TitleEditor';
import { useUpdateImageMutation } from '../../api/image';

interface ImageTitleEditorProps {
    name: string;
    id: string;
    description?: string;
}

export default function ImageTitleEditor(props: ImageTitleEditorProps) {
    // updateImage invalidates the 'Image' tag, so the list and the detail entry
    // both refetch on their own — no manual refetch to thread through
    const [updateImage] = useUpdateImageMutation();

    const handleUpdate = async (id: string, name: string) => {
        await updateImage({
            id,
            name,
            description: props.description // Include the existing description in the update
        }).unwrap();
    };

    return (
        <TitleEditor
            {...props}
            icon={FaRegObjectGroup}
            titleType="image"
            onUpdate={handleUpdate}
        />
    );
} 